import { primaryComponentList } from './component-slots.js';

function finite(value, fallback = 0) {
  const n = Number(value);
  return Number.isFinite(n) ? n : fallback;
}

export function snapshotPrimaryHardware(activeBoxes = []) {
  return primaryComponentList(activeBoxes).map((comp) => ({
    trackType: String(comp.trackType || ''),
    label: String(comp.badgeEl?.textContent || comp.displayLabel || comp.trackType || 'Component'),
    color: Number(comp.categoryColor || 0x94a3b8),
    dims: {
      l: finite(comp.nativeSpecs?.l),
      w: finite(comp.nativeSpecs?.w),
      h: finite(comp.nativeSpecs?.h)
    },
    componentMeta: { ...(comp.componentMeta || {}) }
  }));
}

export function stableSolveFingerprint(caseBox, activeBoxes = []) {
  if (!caseBox) return 'no-case';
  const items = snapshotPrimaryHardware(activeBoxes)
    .map((item) => ({
      trackType: item.trackType,
      dims: item.dims,
      componentMeta: item.componentMeta
    }))
    .sort((a, b) => a.trackType.localeCompare(b.trackType));

  const payload = {
    caseKey: String(caseBox.catalogRecord?.caseKey || caseBox.catalogRecord?._case_key || caseBox.catalogRecord?.name || caseBox.nativeSpecs?.name || ''),
    dims: [finite(caseBox.catalogRecord?.l), finite(caseBox.catalogRecord?.w), finite(caseBox.catalogRecord?.h)],
    modeId: String(caseBox.spatialState?.modeId || 'default'),
    fixedStep: String(caseBox.spatialState?.fixedStep || ''),
    items
  };
  return JSON.stringify(payload);
}
